<template>
  <el-dialog
    :title="'新增地锁'"
    :visible="editFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :modal-append-to-body='false'
    :before-close="clearEditForm">
    <el-form :model="editForm" ref="editForm" size="mini" class="edit_form" >
    <div class="tit">站点信息</div>
      <el-col :span="24">
        <el-form-item label="运营商" :label-width="formLabelWidth" prop="operatorId">
<!--          <el-select placeholder="运营商" :disabled="showFormFlag =='edit'" v-model="editForm.operatorId" @change="operatorSelect">
            <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
          <el-cascader  size="mini" :disabled="showFormFlag =='edit'"
                        placeholder="运营商"  filterable  ref="cascader"
                        :options="this.setTreeDisable(this.operatorForSelect)"
                        :show-all-levels="false"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        change-on-select
                        @change='handleChangeOperator'
                        v-model="editForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="所属场站" :label-width="formLabelWidth" prop="stationId">
          <el-select placeholder="选择站" :disabled="showFormFlag =='edit'" v-model="editForm.stationId" @change="stationSelect">
            <el-option v-for="item in stationsForSelect" :key="item.id"
                       v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="关联充电枪" :label-width="formLabelWidth" prop="gunCode">
          <el-select placeholder="选择站"  v-model="editForm.gunId" @change="stationSelect">
            <el-option v-for="item in qiangSelectList" :key="item.id"
                       v-bind:label="item.gunName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <div class="tit">地锁信息</div>
     <el-col :span="12">
		<el-form-item label="地锁品牌" :label-width="formLabelWidth" prop="lockBrand">
			<el-input placeholder="请输入地锁品牌"  v-model="editForm.lockBrand" autocomplete="off">
			</el-input>
		</el-form-item>
	 </el-col>
     <el-col :span="12">
		<el-form-item label="地锁型号" :label-width="formLabelWidth" prop="lockModel">
			<el-input placeholder="请输入地锁型号"  v-model="editForm.lockModel" autocomplete="off">
			</el-input>
		</el-form-item>
	 </el-col>
     <el-col :span="12">
		<el-form-item label="地锁编号" :label-width="formLabelWidth" prop="lockId">
			<el-input placeholder="请输入地锁编号"  v-model="editForm.lockId" autocomplete="off">
			</el-input>
		</el-form-item>
	 </el-col>
     <el-col :span="12">
		<el-form-item label="安装日期" :label-width="formLabelWidth" prop="installTime">
			<el-date-picker v-model="editForm.installTime" type="date" value-format="yyyy-MM-dd"
				placeholder="选择日期时间"></el-date-picker>
			</el-form-item>
	</el-col>
     <el-col :span="24">
        <el-form-item label="计费开关" :label-width="formLabelWidth" prop="billSwitch">
          <el-select placeholder="选择站"  v-model="editForm.billSwitch">
            <el-option v-for="item in billSwitchList" :key="item.code"
                       v-bind:label="item.name" v-bind:value="item.code"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
     
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="clearEditForm">取 消</el-button>
      <el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "add",
    data(){
      return{
        
        formLabelWidth: '150px',
        billSwitchList:[{
          name:'是',
          code:'Y'
        },
        {
          name:'否',
          code:'N'
        }]
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
      showFormFlag:"",
      operatorForSelect:{},
      stationsForSelect:{},
      qiangSelectList:{},
      pilesForSelect:{},
      editSubmitLoading:false
    },
    methods:{
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      clearEditForm(){
        let _this = this
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
      operatorSelect(val){
        this.$emit("operatorSelect", val)
      },
      stationSelect(val){
        this.$emit("stationSelect", val)
      },
      pileSelect(val){
        this.$emit("pileSelect", val)
      },
      startGunNumCheck(rule, value, callback){
        this.$emit("startGunNumCheck", rule, value, callback)
      },
      endGunNumCheck(rule, value, callback){
        this.$emit("endGunNumCheck", rule, value, callback)
      },
      addMethodChange(val){
        if (val == 1){
          this.$set(this.editForm, 'gunNum', "")
        }else if (val == 2){
          this.$set(this.editForm, 'startGunCode', "")
          this.$set(this.editForm, 'endGunCode', "")
          this.$set(this.editForm, 'startGunNum', "")
          this.$set(this.editForm, 'endGunNum', "")
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
      height: auto;
    .el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
      line-height: 25px;
    }
  }
  .tit{
      text-align: left;
      font-weight: bold;
      margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/parkingLockManager/add.vue